/**
 * API 地址在 npm run build 时由 vue.config.js 写入 __ACADMIN_API_BASE__ 常量。
 * 不再依赖可被服务器旧文件覆盖的 runtime-config.js。
 */
/* global __ACADMIN_API_BASE__ */

export function getApiBase() {
  if (typeof __ACADMIN_API_BASE__ !== 'undefined' && __ACADMIN_API_BASE__) {
    return __ACADMIN_API_BASE__
  }
  if (typeof window !== 'undefined' && window.__ACADMIN_CONFIG__ && window.__ACADMIN_CONFIG__.apiBase) {
    return window.__ACADMIN_CONFIG__.apiBase
  }
  return '/api'
}

export const USE_MOCK = process.env.VUE_APP_USE_MOCK === 'true'
export const API_PROXY_TARGET = process.env.VUE_APP_API_PROXY_TARGET || 'http://localhost:5236'
